import React from "react";
import { Box } from "@mui/material";
import { useIsDesktop } from "../../shared/hooks/useIsDesktop";

/**
 * ページ上部共通ヘッダー
 * - title        : タイトル
 * - leftActions  : タイトル横のアクション（任意）
 * - notice       : バナー
 * - rightActions : 右寄せアクション
 */
const HeaderSection = ({ title, leftActions, notice, rightActions }) => {
  const isDesktop = useIsDesktop();
  return (
    <Box sx={{ mb: 1 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: isDesktop ? "row" : "column",
          alignItems: isDesktop ? "center" : "stretch",
          gap: isDesktop ? 2 : 1,
        }}
      >
        {/* タイトル */}
        {title}

        {/* タイトル横（PDF） */}
        {leftActions && <Box>{leftActions}</Box>}

        {/* バナーと右寄せアクション */}
        <Box
          sx={{
            ml: isDesktop ? "auto" : 0,
            display: "flex",
            flexDirection: isDesktop ? "row" : "column-reverse",
            justifyContent: isDesktop ? "flex-end" : "flex-start",
            gap: 1,
            width: isDesktop ? "auto" : "100%",
            alignItems: isDesktop ? "center" : "stretch",
          }}
        >
          <Box
            sx={{
              alignSelf: isDesktop ? "center" : "stretch",
              width: isDesktop ? "auto" : "100%",
            }}
          >
            {notice}
          </Box>
          <Box
            sx={{
              alignSelf: isDesktop ? "center" : "stretch",
              width: isDesktop ? "auto" : "100%",
            }}
          >
            {rightActions}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default HeaderSection;
